import { render, staticRenderFns } from "./ListCustomers.vue?vue&type=template&id=54a1cd43&scoped=true&"
import script from "./ListCustomers.vue?vue&type=script&lang=js&"
export * from "./ListCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomers.vue?vue&type=style&index=0&id=54a1cd43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1cd43",
  null
  
)

export default component.exports